import React from "react";

import classes from "./DealerCard.module.css";
import pcariLogo from "../../assets/svg/pcariMainToolBarLogo.svg";

const DealerCard = (props) => {
    let dealer = null;
    if (props.dealer) {
        dealer = (
            <div className={classes.DealerCard}>
                <img src={props.dealer.profile_picture ? props.dealer.profile_picture : pcariLogo} alt='user pic' />
                <h1>{props.dealer.name ? props.dealer.name : props.dealer.email}</h1>
            </div>
        )
    }
    return (
        <div className={classes.Container}>
            {dealer}
        </div>
    );
};

export default DealerCard;
